export const HomeHero = () => {
    document.addEventListener("DOMContentLoaded", function () {
        // get the hero element
        const hero = document.getElementById('home-hero');
        if (!hero) return;

        // get all images
        const images = JSON.parse(hero.getAttribute("data-images") || "[]");
        // get all icons
        const icons = JSON.parse(hero.getAttribute("data-icons") || "[]");

        // pick a ranom image
        const randomImage = images[Math.floor(Math.random() * images.length)];

        // pick a random icon
        const randomIcon = icons[Math.floor(Math.random() * icons.length)];

        // get the image and icon elements
        const imageEl = document.querySelector(".home-hero__image");
        const iconEl = document.querySelector(".home-hero__icon");

        // set the image and icon
        if (randomImage) {
            imageEl.src = randomImage.image_url;
            imageEl.alt = randomImage.image_alt;
        }

        if (randomIcon) {
            iconEl.src = randomIcon.icon_url;
            iconEl.alt = randomIcon.icon_alt;
        }
    });
}
